/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';
import config from '@config';

/* Services */

/**
 * Renders the SectionTitle component.
 *
 * @param {object} sectionContent component.
 * @param {object} rest some more data
 * @returns {ReactElement} UymContactUs component
 */
export default function UymContactUs({ sectionContent, region, lang }) {
  return (
    <>
      <Box w={'100%'} m={{base:'10px auto 50px auto', md:'10px auto 0px auto'}} minH={{base:'auto', md:'240px'}}
        bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1734012935-uym_contactus_bg.png)`, "2xl":`url(${config.imgPath}/d/46272/1737037975-uym_contactus_bg1.png)`}}
        bgRepeat={'no-repeat'}
        bgPosition={'right 0px'}
        pt="30px"
        pb={{base:'0px', md:'60px'}}
      >
        <Box width={{base:'90%', md:'680px'}} m="0 auto">
            <Box pt={{base:'10px', md:'10px'}} pb={{base:'20px', md:'10px'}}>
                <SectionTitle titleObj={sectionContent[0]} lang={lang} />
            </Box>
            <Box>
                <StructuredTextParser
                    str={render(sectionContent[1].body)}
                    region={region}
                    lang={lang}
                    textAlign="center"
                    mt="0"
                    className="event-text contact_text"
                />
            </Box>
        </Box>
      </Box>
      <style>
        {`
        .contact_text p {
            font-size: 20px;
            color: #28231E;
            line-height: 34px;
        }
        .contact_text p a {
            color: #F88900;
            text-decoration: none;
            border-bottom: 1px solid;
        }
        @media (max-width: 768px) {
            .contact_text p {
              font-size: 16px;
            }
        }
        `}
      </style>
    </>
  );
}
